import { DATATYPE_ICON_MAPPING } from '../constants/constants';


export function getFieldDataTypeIcon(dataType) {
  return dataType in DATATYPE_ICON_MAPPING
    ? DATATYPE_ICON_MAPPING[dataType]
    : 'datatype';
}
